"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icon_1 = __importDefault(require("../icon"));
function CommonTsx(props) {
    var action = props.action, onCallback = props.onCallback, icon = props.icon, _a = props.titleText, titleText = _a === void 0 ? 'Refine results' : _a, _b = props.clearText, clearText = _b === void 0 ? 'Clear All' : _b, _c = props.initIconUrl, initIconUrl = _c === void 0 ? false : _c, switchHidden = props.switchHidden;
    var _d = (0, react_1.useState)(!initIconUrl), iconUrl = _d[0], setIconUrl = _d[1];
    (0, react_1.useEffect)(function () {
        setIconUrl(!initIconUrl);
    }, [initIconUrl]);
    return (react_1.default.createElement("section", { className: "intl__common-container" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('mask-click', {
                'mask-click--hidden': switchHidden,
            }), onClick: onCallback }),
        react_1.default.createElement("div", { className: "tree__head-container" },
            react_1.default.createElement(icon_1.default, { name: "menu-sub", size: 24 }),
            react_1.default.createElement("span", { className: (0, classnames_1.default)('tree__title', {
                    'tree__title-bold': !iconUrl,
                }) }, titleText)),
        action ? (react_1.default.createElement("div", { className: "tree__head--action" },
            react_1.default.createElement("span", null,
                " ",
                clearText))) : null,
        react_1.default.createElement(TreeIcon, { icon: icon, setIconUrl: setIconUrl, iconUrl: iconUrl, onCallback: onCallback })));
}
exports.default = CommonTsx;
function TreeIcon(props) {
    var icon = props.icon, setIconUrl = props.setIconUrl, iconUrl = props.iconUrl, onCallback = props.onCallback;
    if (Array.isArray(icon)) {
        var iconLeftIcon = icon[0];
        var iconRightIcon = icon[1];
        return (react_1.default.createElement("div", { className: "mb-class", onClick: function (e) {
                e.stopPropagation();
                setIconUrl(!iconUrl);
                onCallback === null || onCallback === void 0 ? void 0 : onCallback();
            } }, iconUrl ? (react_1.default.createElement(icon_1.default, { name: iconLeftIcon, size: 24 })) : (react_1.default.createElement(icon_1.default, { name: iconRightIcon || iconLeftIcon, size: 24 }))));
    }
    return null;
}
//# sourceMappingURL=Common.js.map